/**
 * author: duxin
 * date: 2020/4/23
 * describe: 国际化
 */
import Vue from "vue"
import VueI18n from "vue-i18n"

Vue.use(VueI18n);
import zh from "./zh"
import en from "./en"


const i18n = new VueI18n({
    locale: sessionStorage.getItem("language") === "en" ? "en" : 'zh',
    messages: {
        zh,
        en
    }
});

export default i18n